import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { MetricsLoadingSpinner } from './MetricsLoadingSpinner';
import { Chart } from './chart/Chart';
import { ChartRenderer } from './chart/renderer/ChartRenderer';
import { EmptyState } from './EmptyState';
import { cn } from 'utils/classNamesTailwind';

export function MetricsChart({
  renderer,
  height = 'h-56',
  testId = '',
  className = '',
  emptyState = <EmptyState />,
}: {
  renderer: ChartRenderer | null | undefined;
  height?: string;
  testId?: string;
  className?: string;
  emptyState?: ReactNode;
}) {
  if (renderer instanceof ChartRenderer && renderer.shouldRenderEmptyState() && emptyState) {
    return emptyState;
  }

  return (
    <Box className={cn(`w-full my-4 ${height}`, className)} data-testid={testId}>
      {!renderer ? <MetricsLoadingSpinner /> : <Chart renderer={renderer} />}
    </Box>
  );
}
